export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--2.7d70c6cd.png";